import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { SubscriptionFields } from '../../../../assets/mock-data/auth/subscription-fields';
import { FooterMenuItems } from './footer.utils';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe, NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SocialMediaLinkComponent } from '../social-media-link/social-media-link.component';
import { FooterChidaluComponent } from '../footer-chidalu/footer-chidalu.component';
import { Observable, Subject } from 'rxjs';
import { finalize, map, shareReplay, takeUntil } from 'rxjs/operators';
import { ButtonDetails, ButtonSolidComponent } from '../button-solid/button-solid.component';
import { AuthService, InputDetails, NotificationService } from '../../../core';
import { FormComponent } from '../form/form.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    NgClass,
    RouterLink,
    SocialMediaLinkComponent,
    FooterChidaluComponent,
    AsyncPipe,
    ButtonSolidComponent,
    FormComponent,
  ],
})
export class FooterComponent implements OnInit, OnDestroy {
  isMobile$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map((result) => result.matches),
    shareReplay(),
  );
  errorText: string;
  formSubmit = false;
  subscriptionButton1: ButtonDetails = { text: 'SUBSCRIBE', color: 1, customStyle: 'p-3 rounded-end rounded-0 subscribe-btn' };
  subscriptionButton2: ButtonDetails = { text: 'SUBSCRIBE', color: 1, customStyle: 'py-3 scalped-border-alta rounded-pill subscribe-btn' };
  subscriptionFields: Array<InputDetails> = SubscriptionFields;
  footerMenuItems: any;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
  private destroy$ = new Subject<void>();

  constructor(
    public breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.footerMenuItems = FooterMenuItems;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  subscribeToMailing(form: NgForm): void {
    this.formSubmit = true;
    this.errorText = '';

    if (form.invalid) {
      return;
    }

    this.formSubmit = false;
    this.authService
      .subscribeToMailing(form.value)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          form.reset();
        }),
      )
      .subscribe(
        () => {
          this.notificationService.displaySuccess('Thanks for subscribing.', 'Welcome!');
        },
        (errorMessage) => {
          const errorText = errorMessage ?? 'Oops! The information entered was incorrect. Please check and try again.';
          this.notificationService.displayError(errorText, '');
        },
      );
  }
}
